import { useState, useEffect } from 'react';
import Tooltip from './Tooltip';
import quotesData from '../data/quotes.json';
import { Link } from 'react-router-dom';

export default function Footer(){
    const [lastEditedTime, setLastEditedTime] = useState("Fetching..");
    const [randomQuote, setRandomQuote] = useState(null);
    const [showQuote, setShowQuote] = useState(false);

    const links = [
      { name: "Email", username: "", href: "imajin.dev@gmail.com", type: "text" },
      { name: "Instagram", username: "coding.effects", href: "https://www.instagram.com/coding.effects/", type: "text" },
      { name: "GitHub", username : "yiyujin", href: "https://github.com/yiyujin", logo: "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg", type: "image" },
      { name: "LinkedIn", username : "yujinyi", href: "https://www.linkedin.com/in/yujinyi/", logo: "https://logoeps.com/wp-content/uploads/2014/09/49068-linkedin-logo-icon-vector-icon-vector-eps.png", type: "image" },
      { name: "Calendly", username : "", href: "https://calendly.com/codingeffects/coffee-chat", logo: "/assets/coffee.png", type: "image" },
    ];

    const displayRandomQuote = () => {
      const randomIndex = Math.floor(Math.random() * quotesData.length);
      setRandomQuote(quotesData[randomIndex].content);
      setShowQuote(true);
    };

    const fetchData = async () => {
        try {
          const response = await fetch("https://imajin.dev/api/retrieve-a-database", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
      
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
      
          const result = await response.json();
          const isoDate = result.last_edited_time; //ISO 8601 Timestamp

          const formattedDate = new Date(isoDate).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
          });
      
          setLastEditedTime(formattedDate);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      };  
    
      useEffect( () => {
        fetchData();
        displayRandomQuote();
      }, []);
    
    return(
      <div className = "" style = { { marginTop : "80px", position : "relative",
        // borderTop : "1px solid var(--black56)"
        } }>        
        
        <div style = { { flexWrap : "wrap", display : "flex", flexDirection : "row", gap : "8px", left : 0,  position : "absolute", background : "none", padding : "12px 24px 12px 18vw", borderBottom : "1px solid var(--black56)", borderTop : "1px solid var(--black56)" } }>
          <h3>Last Updated</h3>
            { lastEditedTime !== "Fetching.." &&
              <Tooltip children = {` {  ${ lastEditedTime }  } `} text = "fetched from server, based on the last updated blog post" />
            }
        </div>
        
        <br/><br/><br/><br/>

        <div className = "page" style = { { paddingTop : "0px", paddingBottom : "16px" } }>

          <button style = { { background : "none", border : "none", borderRadius : "1px" } }>
            <a className = "footerLink" href = "/works/170afaf7b684807a85b9c2bddc99d8ea" target = "_blank" style = { { display : "flex", flexDirection : "row", alignItems : "center", gap : "8px", } }>
              <img className = "logo2" src = "/assets/notion.png" />
              <p style = { { padding : 0, margin : 0, fontSize : "var(--font-size-tiny)" } }>Made with Notion API</p>
            </a>
          </button>
          
          <br/><br/>

          { links.map( ( link, index ) => (
            <a
              className = "footerLink"
              key = { index }
              href = { link.href.startsWith('http') ? link.href : (link.type === 'text' && link.name === 'Email' ? 'mailto:' + link.href : link.href) }
              target = { link.href.startsWith('http') ? '_blank' : undefined }
              rel = { link.href.startsWith('http') ? 'noopener noreferrer' : undefined }
              style = { { display : "flex", flexDirection : "row", gap : "4px", alignItems : "center", paddingBottom : "8px", width : "fit-content", cursor : "pointer", textDecoration : "none" } }
            >
              <p className = "meta" style = { { fontWeight : 500, textDecoration : "none" } }>{ link.name }</p>
              <p className = "meta2" style = { { textDecoration : "underline" } }>{ link.href }</p>
            </a>
            ))
          }

          <a href = "https://drive.google.com/file/d/1g5iJY07Mgyh7G7cdeAjYhEP0oWStnY5A/view" target = "_blank">Resume</a>

          <br/>

          {/* <img className = "footerImg" style = { { right : 0, paddingTop : "-24px"  } } src = { process.env.PUBLIC_URL + '/assets/footer.png' }/> */}

          <br/>

          { showQuote && randomQuote && (
            <div style = { { paddingLeft : "16%", display : "flex", flexDirection : "row", gap : "16px", cursor : "pointer", alignItems : "flex-start" } }>

              <Link to = "/works/170afaf7-b684-80e3-a118-c72096f5710e" className = "footerLink" style = { { display : "flex", flexDirection : "column", alignItems : "center", gap : "2px" } }>
                <div style = { { width : "44px", height : "44px", background : "white", borderRadius : "8px", border : "1px solid var(--black4)", justifyContent : "center", alignItems : "center", display : "flex", overflow : "hidden" } }>
                  <img src = "/assets/quotesLogo.png" style = { { width : "24px" } } />
                </div>
                <p style = { { fontSize : "var(--font-size-teeny)", color : "var(--black80)" } }>Quotes</p>
              </Link>
              

              <p key = {randomQuote}
                onClick = { displayRandomQuote }
                style = { { 
                fontSize : "var(--font-size-tiny)",
                fontFamily : "var(--font-Source)",
                animation: "blurFade 1s ease-out",
                flex : 1,
                width : "100%",
                minHeight : "160px",
                wordBreak : "keep-all",
                overflowWrap : "break-word",
              } }>
                { randomQuote }
              </p>
              <style>
                {`
                  @keyframes blurFade {
                    0% { 
                      opacity: 0.6; 
                      filter: blur(10px); 
                    }
                    100% { 
                      opacity: 1; 
                      filter: blur(0px); 
                    }
                  }
                `}
              </style>
            </div>
          )}

        </div>
      </div>
    );
}